export const defaultPageSize = 20;
export const bookDemoUrl = "https://elofleet.com/book-demo";
